// frontend/src/utils/statusOptions.js
export const getStatusOptions = (mediaType) => {
  switch (mediaType) {
    case 'ShowsAndMovies':
    case 'Anime':
    case 'AnimeMovie':
    case 'AnimeSerie':
    case 'TV':
    case 'ScreenMedia':
      return ['Finished', 'Watching', 'Dropped', 'Forgotten', 'On Hold', 'Plan to Watch'];
    case 'Movie':
      return ['Finished', 'Plan to Watch'];
    case 'Manga':
      return ['Reading', 'Dropped', 'On Hold', 'Forgotten', 'Plan to Read', 'Finished'];
    case 'SteamGame':
    case 'PhysicalGame':
    case 'PSPGame':
    case 'NDSGame':
    case 'GameboyGame':
    case 'SwitchGame':
    case 'PS3Game':
    case 'VitaGame':
      return ['Completed', 'Playing', 'Not Playing', 'Forgotten', 'Unplayed', 'Dropped'];
    case 'Music':
    case 'Vinyl':
    case 'CD':
      return ['Listened', 'Not Listened'];
    case 'All':
      // Union of every status across every media type, so the combined "All Media" list
      // shows the full vocabulary instead of just the generic 'Unknown' fallback.
      return [
        'Finished', 'Watching', 'Dropped', 'Forgotten', 'On Hold', 'Plan to Watch',
        'Reading', 'Plan to Read',
        'Completed', 'Playing', 'Not Playing', 'Unplayed',
        'Listened', 'Not Listened',
      ];
    default:
      return ['Unknown'];
  }
};

const getSingleOwnershipOptions = (mediaType) => {
  switch (mediaType) {
    case 'Manga':
      return ['Not Owned', 'Wishlisted', 'Collecting', 'Owned'];
    case 'PhysicalGame':
    case 'PSPGame':
    case 'NDSGame':
    case 'GameboyGame':
    case 'SwitchGame':
    case 'PS3Game':
    case 'VitaGame':
    case 'Music':
    case 'Vinyl':
    case 'CD':
      return ['Not Owned', 'Wishlisted', 'Owned'];
    default:
      return [];
  }
};

// Accepts either a single media type or an array of them (e.g. a combined list mixing
// PhysicalGame + Manga) and returns the union of applicable ownership options, so a
// combined list of types with different ownership vocabularies (like Manga's extra
// "Collecting" status) still shows every relevant option.
export const getOwnershipOptions = (mediaTypeOrTypes) => {
  const types = Array.isArray(mediaTypeOrTypes) ? mediaTypeOrTypes : [mediaTypeOrTypes];
  const merged = [];
  types.forEach((t) => {
    getSingleOwnershipOptions(t).forEach((opt) => {
      if (!merged.includes(opt)) merged.push(opt);
    });
  });
  return merged;
};